import stripTags from './stripTags';
var headingPlainText = function (value, fallback) {
    if (fallback === void 0) { fallback = ''; }
    if (typeof value !== 'string') {
        return fallback;
    }
    var plain = stripTags(value).replace(/\s+/g, ' ').trim();
    return plain || fallback;
};
export default headingPlainText;
